/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedDefs from './defs.defs.js'

const $nsid = 'app.bsky.embed.images'

export { $nsid }

type Main = { $type?: 'app.bsky.embed.images'; images: Image[] }

export type { Main }

const main = l.typedObject<Main>(
  $nsid,
  'main',
  l.object({
    images: l.array(l.ref<Image>((() => image) as any), { maxLength: 4 }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type Image = {
  $type?: 'app.bsky.embed.images#image'

  /**
   * The raw image file. May be up to 2 MB, formerly limited to 1 MB.
   */
  image: l.BlobRef

  /**
   * Alt text description of the image, for accessibility.
   */
  alt: string
  aspectRatio?: EmbedDefs.AspectRatio
}

export type { Image }

const image = l.typedObject<Image>(
  $nsid,
  'image',
  l.object({
    image: l.blob({ accept: ['image/*'], maxSize: 2000000 }),
    alt: l.string(),
    aspectRatio: l.optional(
      l.ref<EmbedDefs.AspectRatio>((() => EmbedDefs.aspectRatio) as any),
    ),
  }),
)

export { image }

type View = { $type?: 'app.bsky.embed.images#view'; images: ViewImage[] }

export type { View }

const view = l.typedObject<View>(
  $nsid,
  'view',
  l.object({
    images: l.array(l.ref<ViewImage>((() => viewImage) as any), {
      maxLength: 4,
    }),
  }),
)

export { view }

type ViewImage = {
  $type?: 'app.bsky.embed.images#viewImage'

  /**
   * Fully-qualified URL where a thumbnail of the image can be fetched. For example, CDN location provided by the App View.
   */
  thumb: l.UriString

  /**
   * Fully-qualified URL where a large version of the image can be fetched. May or may not be the exact original blob. For example, CDN location provided by the App View.
   */
  fullsize: l.UriString

  /**
   * Alt text description of the image, for accessibility.
   */
  alt: string
  aspectRatio?: EmbedDefs.AspectRatio
}

export type { ViewImage }

const viewImage = l.typedObject<ViewImage>(
  $nsid,
  'viewImage',
  l.object({
    thumb: l.string({ format: 'uri' }),
    fullsize: l.string({ format: 'uri' }),
    alt: l.string(),
    aspectRatio: l.optional(
      l.ref<EmbedDefs.AspectRatio>((() => EmbedDefs.aspectRatio) as any),
    ),
  }),
)

export { viewImage }
